import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "../useAxios";
import { useTranslation } from "react-i18next";
import { App } from "antd";

export const useEditParticipant = () => {

    const axios = useAxios();
    const queryClient = useQueryClient();
    const {t} = useTranslation();
    const {message} = App.useApp();

    const editParticipant = async (participant: any) => {
        try {
            const {data} = await axios.put(`/api/participant`, participant);
            return data;
        } catch (error) {
            throw new Error(t("errorMessages.editParticipant"));
        }
    }

    return useMutation({ mutationFn: editParticipant, onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["participants"] });
        message.success(t("successMessages.editParticipant"));
    }});

}
